import {PageManager} from '@mvps-genesis/core';
import readMore from 'Extensions/read-more';
import stickyFill from 'Extensions/sticky-fill';
import {bootstrapHawksearch} from 'extensions/hawksearch/pages/category';

export default class CTGY extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		bootstrapHawksearch();
	}

	onReady () {

		stickyFill();
		this.readMore();
		this.readMoreHeader();

	}

	readMore () {
		const aboutBanner = document.querySelector('.about-banner-description');
		if (aboutBanner) {
			readMore('.about-banner-description');
		}
	}

	readMoreHeader () {
		this.initReadMoreHeader();

		const hawkHeader = document.getElementById('js-category-header-descrip');
		if (!hawkHeader) {
			return;
		}

		const observer = new MutationObserver(() => {
			this.initReadMoreHeader();
		});

		observer.observe(hawkHeader, {
			attributes: true,
			characterData: true,
			childList: true
		});
	}

	initReadMoreHeader () {
		const elements = document.getElementsByClassName('x-category-read-more');
		const readMoreShownClass = 'x-category-read-more--shown';
		const readMoreHiddenClass = 'x-category-read-more--hidden';
		const readMoreNoneClass = 'x-category-read-more--none';
		const readMoreInitializedClass = 'x-category-read-more--initalized';

		for (const element of elements) {
			if (element.classList.contains(readMoreInitializedClass)) {
				continue;
			}

			element.classList.add(readMoreInitializedClass);

			const readMoreWrapper = document.createElement('div');
			readMoreWrapper.classList.add('x-category-read-more--outer');
			element.parentNode.insertBefore(readMoreWrapper, element);
			readMoreWrapper.appendChild(element);

			if (element.scrollHeight <= element.clientHeight) {
				element.classList.add(readMoreNoneClass);
				element.classList.add(readMoreShownClass);
				continue;
			}

			const readMoreToggle = document.createElement('span');
			readMoreToggle.classList.add('x-category-read-more-toggle');
			readMoreWrapper.appendChild(readMoreToggle);

			element.classList.add(readMoreHiddenClass);
			readMoreToggle.addEventListener('click', () => {
				element.classList.toggle(readMoreHiddenClass);
				element.classList.toggle(readMoreShownClass);
			});
		}
	}


}
